import { render } from "./RecordsContainer.vue?vue&type=template&id=14a86784&scoped=true&ts=true"
import script from "./RecordsContainer.vue?vue&type=script&lang=ts"
export * from "./RecordsContainer.vue?vue&type=script&lang=ts"

import "./RecordsContainer.vue?vue&type=style&index=0&id=14a86784&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a86784"]])

export default __exports__